import React, { useState, useRef, useEffect } from "react";
import "./GetQuoteOverlay.css";
import { CLOUDINARY_CONFIG } from "../../Components/config";
import axios from 'axios';
import { db } from "../../Components/firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  doc,
  getDoc
} from "firebase/firestore";
import { useAuth } from "../../AuthContext";

const GetQuoteOverlay = ({ postId, onClose }) => {
  const { currentUser } = useAuth();
  
  const [vehicleInfo, setVehicleInfo] = useState({
    year: "",
    make: "",
    model: "",
    trim: "",
  });
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);

  const [serviceLocation, setServiceLocation] = useState("");
  const [preferredServiceAddress, setPreferredServiceAddress] = useState("");
  const [desiredServiceDateTime, setDesiredServiceDateTime] = useState("");

  const handleVehicleChange = (e) => {
    const { name, value } = e.target;

    setVehicleInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchServiceLocation = async () => {
      try {
        const postRef = doc(db, "Posts", postId);
        const postSnap = await getDoc(postRef);

        if (postSnap.exists()) {
          setServiceLocation(postSnap.data().serviceLocation || "");
        }
      } catch (error) {
        console.error("Error fetching serviceLocation:", error);
      }
    };

    if (postId) {
      fetchServiceLocation();
    }
  }, [postId]);

  const handleSubmit = async () => {
    if (!currentUser) {
      alert("Login required");
      return;
    }

    try {
      const requestedQuoteInfo = {
        userId: currentUser.uid,
        directoryPostId: postId,
        vehicleInfo,
        additionalInfo,
        images,
        preferredServiceAddress,
        desiredServiceDateTime,
        createdAt: serverTimestamp(),
      };

      // Creates:
      // Posts/{postId}/Requested Quotes/{autoGeneratedDocId}
      const requestedQuotesRef = collection(
        db,
        "Posts",
        postId,
        "Requested Quotes"
      );

      await addDoc(requestedQuotesRef, requestedQuoteInfo);

      // Reset form
      setVehicleInfo({
        year: "",
        make: "",
        model: "",
        trim: "",
      });

      setAdditionalInfo("");
      setPreferredServiceAddress("");
      setDesiredServiceDateTime("");
      setImages([]);

      onClose();
    } catch (error) {
      console.error("Error submitting quote request:", error);
      alert("Failed to submit quote request.");
    }
  };

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    if (images.length + files.length > 7) {
      alert("⚠️ You can only upload up to 7 images.");
      return;
    }

    setUploading(true);

    try {
      const uploads = files.map(file => {
        const fd = new FormData();
        fd.append("file", file);
        fd.append("upload_preset", CLOUDINARY_CONFIG.preset);

        return axios.post(
          `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/image/upload`,
          fd
        );
      });

      const results = await Promise.all(uploads);
      const urls = results.map(r => r.data.secure_url);

      setImages(prev => [...prev, ...urls]);
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="fbo-overlay-backdrop" onClick={onClose}>
      <div className="fbo-overlay-container" onClick={(e) => e.stopPropagation()}>
        <div className="fbo-header">
          <h2>Get Quote</h2>
          <button className="fbo-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="fbo-content">

          <label>Vehicle Information</label>

          <div className="fbo-vehicle-grid">
            <input
              type="number"
              name="year"
              min="1900"
              max="2099"
              value={vehicleInfo.year}
              onChange={handleVehicleChange}
              placeholder="Year"
            />

            <input
              type="text"
              name="make"
              value={vehicleInfo.make}
              onChange={handleVehicleChange}
              placeholder="Make"
            />

            <input
              type="text"
              name="model"
              value={vehicleInfo.model}
              onChange={handleVehicleChange}
              placeholder="Model"
            />

            <input
              type="text"
              name="trim"
              value={vehicleInfo.trim}
              onChange={handleVehicleChange}
              placeholder="Trim"
            />
          </div>

          <label>Additional Information</label>
          <textarea
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
            placeholder="Enter any special instructions"
          />

          {serviceLocation === "Customer Address" && (
            <>
              <label>Your Preferred Address for Service</label>

              <input
                type="text"
                value={preferredServiceAddress}
                onChange={(e) => setPreferredServiceAddress(e.target.value)}
                placeholder="Enter service address"
              />
            </>
          )}

          <label>Desired Date and Time for Service</label>

          <input
            type="datetime-local"
            value={desiredServiceDateTime}
            onChange={(e) => setDesiredServiceDateTime(e.target.value)}
          />

          <label>Upload Images (optional)</label>

          <div className="fbo-upload-container">

            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageUpload}
            />

            {uploading && (
              <p className="uploading-text">Uploading images...</p>
            )}

            {images.length > 0 && (
              <div className="fbo-preview-gallery">
                {images.map((img, i) => (
                  <div
                    key={i}
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <img
                      src={img}
                      alt={`Uploaded ${i}`}
                      className="fbo-preview-media"
                    />

                    <button
                      type="button"
                      onClick={() => handleRemoveImage(i)}
                      className="fbo-remove-img"
                    >
                      ✖
                    </button>
                  </div>
                ))}
              </div>
            )}

          </div>

        </div>

        <div className="fbo-footer">
          
          <div className="add-to-cart-wrapper">
            <button 
              className="addtoCart1" 
              onClick={handleSubmit}
            >SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetQuoteOverlay;